// extracted by mini-css-extract-plugin
export default {"empty":"SnapshotListEntries_empty__m7Fw0","pagination":"SnapshotListEntries_pagination__TjP18","remove-scroll-shadow":"SnapshotListEntries_remove-scroll-shadow__LlPPy"};